module.exports = {
	"concepts": [{
			"title": "Social construction of race",
			"definition": "acknowledges that race is socially constructed through social interactions and whose meanings change over time and space. An example from history is how different states in the U.S. defined who was Black using different criteria. In some places 1/8th or 1/4th or any amount of Black ancestry defined a person as Black.",
			"reference": "Omi, M., & Winant, H. (2015). <i>Racial formation in the U.S. (3rd ed.).</i> New York, NY: Routledge."
		},
		{
			"title": "Racialized social systems",
			"definition": "Bonilla-Silva (1997) referred to racialized social systems as those where economics, politics, belief systems, and social relations are structured by how race operates and people get racially categorized. Whiteness has played a central role in helping to maintain racism in these systems.",
			"reference": "Lewis, A.E., Hagerman, M.A., & Forman, T.A. (2019). The sociology of race & racism: Key concepts, contributions & debates. <i>Equity & Excellence in Education, 52</i>(1), 29-46."
		},
		{
			"title": "Institutional racism",
			"definition": "is a system of White domination of people of color that does not rely on how individual people feel about and act regarding race. It is found in and operates in societal institutions like our legal system, education systems—universities and K-12, political systems and bodies, cultural life, and corporations. Institutional racism is not dependent on how individual people think about or act in relation to race.",
			"reference": "Desmond, M. & Emirbayer, M. (2015). <i>Race in America.</i>New York: Norton."
		},
		{
			"title": "Interpersonal racism",
			"definition": "is a form of race domination found in everyday interactions between people. It relies on social practices and historical legacies of racial domination. Interpersonal racism can be overt (prejudice beliefs and practices) or covert (practices found in everyday life that often go unquestioned and are viewed as socially accepted and ordinary in the dominant culture.",
			"reference": "Desmond, M. & Emirbayer, M. (2015). <i>Race in America.</i>New York: Norton."
		},
		{
			"title": "Racial subjectivity",
			"definition": "is how people develop and understand themselves as having a racial identity.",
			"reference": "Lewis, A. E. (2003). Race in the schoolyard: Negotiating the color line in classrooms and communities. Rutgers University Press."
		},
		{
			"title": "Critical Race Theory",
			"definition": "emerged as a response to criticisms of critical legal studies, a theoretical approach that while concerned about how law itself helped to maintain societal inequity, failed to address how the construct of race and the practice of racism operated in these processes.",
			"subconcepts": [{
					"key": 1,
					"title": "Racial realism",
					"definition": "the argument that race holds a foundational and permanent role in the sociopolitical and economic fabric of U.S. society."
				},
				{
					"key": 2,
					"title": "Whiteness as property",
					"definition": "the recognition that the values, knowledge, behavior, and experiences associated with Western, Anglo-Saxon, Protestant perspectives offer rights and privileges, including the right to disposition, the right to use and to enjoy, and the right to exclude."
				},
				{
					"key": 3,
					"title": "Interest convergence",
					"definition": "the strategy of addressing racial inequities in the context of remedies that serve and maintain dominant White interests."
				},
				{
					"key": 4,
					"title": "Counter-storytelling",
					"definition": "calls attention to the voices of marginalized people of color by listening to how their own experiences, and the knowledge that emerges from them, illuminate and disrupt dominant narratives about race, racism and racial progress in society and schools."
				},
				{
					"key": 5,
					"title": "Intersectionality",
					"definition": "exploring the multiple ways that race and other identity categories like gender and social class, co-exist, intersect, and operate in our society and in people’s everyday lives."
				}
			],
			"reference": "Brown, K.D. (2014). Teaching in color: Race, sociocultural knowledge and the preparation of teachers in the U.S. <i>Race Ethnicity and Education, 17</i>(3), 326-345."
		}
	],
	"references": [
		"Desmond, M. & Emirbayer, M. (2015). <i>Race in America.</i> New York: Norton.",
		"Lewis, A. E. (2003). <i>Race in the schoolyard: Negotiating the color line in classrooms and communities.</i> Rutgers University Press.",
		"Lewis, A.E., Hagerman, M.A., & Forman, T.A. (2019). The sociology of race & racism: Key concepts, contributions & debates. <i>Equity & Excellence in Education, 52</i>(1), 29 - 46. ",
		"Omi, M. & Winant, H. (2015). <i>Racial formation in the U.S. (3rd ed.).</i> New York, NY: Routledge."
	]
}